import { StaticProvider } from '@angular/core';
import { FeatureServiceDef, provideFeature } from '@y42/feature';
import { Y42GitFolders } from '@y42/feature/git';
import { Y42Routes } from '@y42/feature/routing';
import { Y42FeatureType } from '@y42/json-schema';
import { StatusAlertService } from '../../api';
import { StatusAlertQuery } from '../../state';
import { StatusAlertAclService } from '../../state/status-alert-acl.service';
import { StatusAlertGitService } from '../../state/status-alert-git.service';
import { StatusAlertStore } from '../../state/status-alert.store';

export const StatusAlertFeatureProviders: () => FeatureServiceDef = () => {
  return {
    FEATURE_TYPE: Y42FeatureType.StatusAlert,
    GIT_FOLDER: Y42GitFolders.AlertStatusAlert,
    FEATURE_ROUTE: Y42Routes.AlertStatusAlert,
    DETAIL_TABS: [],
    AbstractFeatureService: StatusAlertService,
    AbstractFeatureQueryEntity: StatusAlertQuery,
    AbstractFeatureEntityStore: StatusAlertStore,
    AbstractFeatureGitService: StatusAlertGitService,
    AbstractFeatureAclService: StatusAlertAclService,
    AbstractFeatureChildQueryEntity: null,
  };
};

export function StatusAlertProviders(): StaticProvider[] {
  return provideFeature(StatusAlertFeatureProviders());
}
